<template>
  <integration-tab-wrapper heading="Google Calendar" logo-path="/images/google-calendar-icon.png" :is-onboarding-integration="isOnboardingIntegration">
    <section-page :class="{ 'is-danger' : calendarHasError }">
      <div class="columns">
        <div class="column is-5">
          <!-- Integration is not yet done or successful -->
          <template v-if="!calendarHasError">
            <!-- State message before integration -->
            <p v-if="!calendarIsComplete" class="integration_message">Tie your Google Calendar account with Forefront so
              that we can add your lead appointments to your Google Calendar.</p>
            <!-- State message after integration -->
            <p v-else class="integration_message">You have successfully connected Google Calendar with Forefront.</p>

            <!-- Instructions before integration -->
            <template v-if="!calendarIsComplete">
              <app-instruction :number="1">Click 'Integrate with Google Calendar' button.</app-instruction>
              <app-instruction :number="2">When you are transferred to Google, sign in to your google account if you are
                not already.
              </app-instruction>
              <app-instruction :number="3">Authorize Forefront to access your Calendar.</app-instruction>
              <app-instruction :number="4">Sync to the calendar you want to use.</app-instruction>
            </template>
          </template>
          <!-- Integration Failed -->
          <template v-else>
            <p class="integration_message" v-if="googleCalendarIntegration.token.error_description">Integration Failed:
              {{ googleCalendarIntegration.token.error_description }}</p>

            <!-- Instructions for failed integration -->
            <app-instruction :number="1">Please disconnect and reconnect your calendar.</app-instruction>
            <app-instruction :number="2">Contact support if it's still not working.</app-instruction>
          </template>
        </div>

        <div class="column is-7">
          <google-calendar-integration/>
        </div>
      </div>
    </section-page>
  </integration-tab-wrapper>
</template>

<script>
import IntegrationBackButton from "../components/IntegrationBackButton.vue";
import GoogleCalendarIntegration from "../components/GoogleCalendarIntegration.vue";
import IntegrationTabWrapper from "../components/IntegrationTabWrapper.vue";
export default {
  name: "IntegrationGoogleCalendar",
  components: {IntegrationTabWrapper, IntegrationBackButton, GoogleCalendarIntegration},
  props: {
    isOnboardingIntegration: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    googleCalendarIntegration() {
      return this.$store.getters.googleCalendarIntegration;
    },
    calendarHasError() {
      return this.$store.getters.googleCalendarIntegrationError;
    },
    calendarIsComplete() {
      return this.$store.getters.googleCalendarIsIntegrated;
    },
  },
}
</script>

<style lang="scss" scoped>

.integration_message {
  margin-bottom: 10px;
  line-height: 1.3;
}
</style>
